import { Injectable, inject } from '@angular/core';
import { ApiService } from '../../../shared/services/api.service';
import {
  ILabCustomTag,
  ILabCustomTagCreate,
  ILabCustomTagListResponse,
} from '../models/LabCustomTag';

/**
 * Client for the lab custom post-analysis tag registry
 * (`api/lab-custom-tags/`). Lists the lab's existing custom tags for the
 * picker and creates new ones (with predefined-collision / adopt handled
 * server-side).
 */
@Injectable({ providedIn: 'root' })
export class LabCustomTagService {
  private readonly apiService = inject(ApiService);
  private readonly root = 'api/lab-custom-tags';

  /** List the file's lab custom tags (with options) for the picker. */
  public listForFile(fileId: number) {
    const url = this.apiService.buildFullURL(this.root, `?file=${fileId}`);
    return this.apiService.get<ILabCustomTagListResponse>(url, { withCredentials: true });
  }

  /** Create a new lab custom tag scoped to the file's lab. */
  public create(payload: ILabCustomTagCreate) {
    const url = this.apiService.buildFullURL(this.root, ``);
    return this.apiService.post<ILabCustomTag>(url, payload, { withCredentials: true });
  }
}
